import React, { FC, useState } from 'react'

import { Modal, StandardButton, Txt } from 'src/components/atoms'

import { useCommonContentAsset, useGetCommonContentPages, useToast } from 'src/hooks'
import { formatDate } from 'src/libs/date'
import { getFileSize } from 'src/libs/helper'
import { CommonContentAssetEntity } from 'src/types'

type Props = {
  asset: CommonContentAssetEntity
  updatedByEmail: string
  isOpen: boolean
  onClose: () => void
}

export const CommonContentAssetFileDeleteModal: FC<Props> = ({
  asset,
  updatedByEmail,
  isOpen,
  onClose,
}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const { deleteContentToAsset } = useCommonContentAsset()
  const { refetch } = useGetCommonContentPages()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnDelete = async () => {
    setIsDeleting(true)

    try {
      await deleteContentToAsset(asset)
      displayStandardTextToast('保存しました')
      refetch()
      onClose()
    } catch {
      displayErrorTextToast('保存に失敗しました')
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="md">
      <div className="tw-w-[33.21rem] tw-p-s2">
        <div className="tw-flex tw-flex-col tw-items-center">
          <Txt sizeType="l" className="tw-font-bold !tw-text-[1.57rem]">
            アップロードファイルを削除します
          </Txt>

          <div className="tw-text-standardText-secondary tw-w-fit tw-mt-s3 tw-grid tw-gap-r-2">
            <Txt sizeType="s" className="tw-break-all">{`コンテンツ名：${asset.name}`}</Txt>
            <Txt sizeType="s" className="tw-break-all">{`ファイル名：${asset.fileName}`}</Txt>
            <Txt sizeType="s" className="tw-break-all">{`更新日：${formatDate(
              asset.uploadedAt,
              'YYYY/MM/DD, hh:mm'
            )}`}</Txt>
            <Txt sizeType="s" className="tw-break-all">{`更新者：${updatedByEmail}`}</Txt>
            <Txt sizeType="s" className="tw-break-all">{`サイズ：${getFileSize(
              asset.fileSize
            )}`}</Txt>
          </div>
        </div>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="削除"
            prependIconPath="trash/soft/line"
            isLoading={isDeleting}
            size="l"
            onClick={handleOnDelete}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
